import { render, staticRenderFns } from "./SectionBannerDetail.vue?vue&type=template&id=445affdd&scoped=true"
import script from "./SectionBannerDetail.vue?vue&type=script&lang=js"
export * from "./SectionBannerDetail.vue?vue&type=script&lang=js"
import style0 from "./SectionBannerDetail.vue?vue&type=style&index=0&id=445affdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445affdd",
  null
  
)

export default component.exports